var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7732 1.25H21C21.4142 1.25 21.75 1.58579 21.75 2C21.75 2.41421 21.4142 2.75 21 2.75H18.75V7H20C20.5523 7 21 7.44772 21 8V21C21 21.0863 20.9891 21.1701 20.9685 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H3.0315C3.01094 21.1701 3 21.0863 3 21V18C3 17.4477 3.44772 17 4 17H5.25V11.8772L5.07664 12.0348C4.57044 12.495 3.91089 12.75 3.22679 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H3.22679C3.53774 11.25 3.83754 11.1341 4.06763 10.9249L13.9234 1.96516C14.4296 1.50498 15.0891 1.25 15.7732 1.25ZM17.25 2.75H15.7732C15.4623 2.75 15.1625 2.8659 14.9324 3.07507L12.75 5.05905V12H15V8C15 7.44772 15.4477 7 16 7H17.25V2.75ZM11.25 6.42269L6.75 10.5136V17H9V13C9 12.4477 9.44772 12 10 12H11.25V6.42269Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.691b796c63168e03ef231f98f0bb436b.svg";
export { ForwardRef as ReactComponent };